import { Roles, SupervisionType } from '../../../constants';
import { FORTA_DOCS } from '../../../utils/colors';

export const HD_CALENDAR_WEEK_DATE_LS_KEY = 'hdCalendarWeekDate';

export const CALENDAR_ROW_DURATION = 4; // Number of hours. Should divide 24 so that there is no reminder left

export const ROW_HEIGHT = 120;

export const CALENDAR_TIME_UNIT = 900; // 15 mins

const TIME_UNITS_PER_HOUR = 3600 / CALENDAR_TIME_UNIT;

export const TIME_UNIT_HEIGHT = ROW_HEIGHT / (TIME_UNITS_PER_HOUR * CALENDAR_ROW_DURATION); // Eg. Four hour window is divided into windows of 15 mins

export enum DocumentMapEnum {
  ASSESSMENT = SupervisionType.Assessment,
  BT_SN = SupervisionType.Bt,
  CLIENT_SN = SupervisionType.Client,
  GROUP_TRAINING = SupervisionType.GroupParent,
  PARENT_SN = SupervisionType.Parent,
  SESSION = 'session',
}

export const ROLE_BASED_ALLOWED_CALLS = {
  [Roles.Bcba]: [
    DocumentMapEnum.ASSESSMENT,
    DocumentMapEnum.BT_SN,
    DocumentMapEnum.CLIENT_SN,
    DocumentMapEnum.GROUP_TRAINING,
    DocumentMapEnum.PARENT_SN,
  ],
};

export const calendarCardStyles = {
  [SupervisionType.Parent]: {
    name: 'Parent Supervision',
    color: FORTA_DOCS.PSN_56,
  },
  [SupervisionType.Client]: {
    name: 'Client Supervision',
    color: FORTA_DOCS.CSN_55,
  },
  [SupervisionType.Bt]: {
    name: 'BT Supervision',
    color: FORTA_DOCS.BTSN,
  },
  [SupervisionType.Assessment]: {
    name: 'Assessment',
    color: FORTA_DOCS.AN_51,
  },
  [SupervisionType.Assessment2]: {
    name: 'Assessment',
    color: FORTA_DOCS.AN_52,
  },
  [SupervisionType.GroupParent]: {
    name: 'Group Supervision',
    color: FORTA_DOCS.GPSN_57,
  },
  session: {
    name: 'Direct Session',
    color: FORTA_DOCS.SN_53,
  },
};
